export default "__VITE_ASSET__DnMNBgbO__"